// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-container--desktop {
    display: grid;
    grid-template-columns: auto 1fr;
}

.page-layout__secondary-content {
    background: var(--app-primary-bg-color-white);
}

.page-layout__secondary-content--desktop {
    position: relative;
}

.page-layout__secondary-content--desktop .app-header{
    padding-top: 42px;
}
.page-layout__content--desktop {
    position: relative;
}

.page-layout__sidebar{
    overscroll-behavior: contain;
    z-index: 9;
}
.page-layout__content-wrapper.page-layout__content--desktop-closed {
    padding-left: 84px;
}
.page-layout__content-wrapper{
    overflow: auto;
    padding: var(--safe-area-top) 0 var(--safe-area-bottom) 0;
}
@media screen and (min-width: 960px) {
    .page-layout__content-wrapper {
        display: grid;
        flex-direction: row-reverse;
        grid-template-columns: 2fr 3fr;
        height: 100vh;
    }
    .page-layout__dashboard--desktop .page-layout__content-wrapper,
    .page-layout__content--co2meters.page-layout__content-wrapper {
        grid-template-columns: 3fr 2fr;
    }
    .page-layout__secondary-content {
        position: relative;
        grid-column: 2 /2;
        grid-row: 1;
    }

    .page-container--desktop.page-layout__dashboard--desktop {

        grid-template-columns: auto  1fr;
        grid-column: 1 / 1;
    }

    .page-content {
        width: 100%;
    }

    .page-layout__content.page-layout__primary-content {
        border-right: 1px solid var(--app-border-secondary-color-light);
    }

    .page.page-smart-home.page-desktop{
        position: absolute;
        left: 80px;
        right: 0;
    }

}

@media screen and (min-width: 1125px) {
    .page-layout__sidebar{
        position: relative;
        width: 285px;
    }
    .page.page-smart-home.page-desktop{
        position: absolute;
        left: 0;
        right: 0;
    }

}

@media screen  and (min-width: 1280px) {
    .page-layout__content-wrapper {
        max-width: 1280px;
        margin: 0 auto;
        width: 100%;
    }
}
@media screen and (min-width: 1620px){


    .parent-page .page-content{
        padding-left: 0 ;
    }
    .parent-page .page-content{
        padding-left: 0 ;
    }

    .child-page .page-content{
        padding-right: 0 ;
    }

}

.child-page.page-layout__content > .page{
    position: sticky;
    top: 0;
    overflow: auto;
}
.parent-page {
    overflow: auto;
    min-width: 320px;
}
.parent-page::-webkit-scrollbar {
    width: 3px;
    height: auto;
    background-color: white;
}
.parent-page::-webkit-scrollbar-thumb{
    background-color: var(--app-secondary-color__bg-gray);
    border-radius: 20px;
}

.page-smart-home .page-layout__content.page-layout__primary-content{
    border-right: none;
}
`, "",{"version":3,"sources":["webpack://./src/core/components/layout/PageLayout/styles/PageLayout.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,UAAU;AACd;AACA;IACI,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,yDAAyD;AAC7D;AACA;IACI;QACI,aAAa;QACb,2BAA2B;QAC3B,8BAA8B;QAC9B,aAAa;IACjB;IACA;;QAEI,8BAA8B;IAClC;IACA;QACI,kBAAkB;QAClB,iBAAiB;QACjB,WAAW;IACf;;IAEA;;QAEI,gCAAgC;QAChC,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,+DAA+D;IACnE;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,QAAQ;IACZ;;AAEJ;;AAEA;IACI;QACI,kBAAkB;QAClB,YAAY;IAChB;IACA;QACI,kBAAkB;QAClB,OAAO;QACP,QAAQ;IACZ;;AAEJ;;AAEA;IACI;QACI,iBAAiB;QACjB,cAAc;QACd,WAAW;IACf;AACJ;AACA;;;IAGI;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;AAEJ;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,cAAc;AAClB;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,YAAY;IACZ,uBAAuB;AAC3B;AACA;IACI,qDAAqD;IACrD,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".page-container--desktop {\n    display: grid;\n    grid-template-columns: auto 1fr;\n}\n\n.page-layout__secondary-content {\n    background: var(--app-primary-bg-color-white);\n}\n\n.page-layout__secondary-content--desktop {\n    position: relative;\n}\n\n.page-layout__secondary-content--desktop .app-header{\n    padding-top: 42px;\n}\n.page-layout__content--desktop {\n    position: relative;\n}\n\n.page-layout__sidebar{\n    overscroll-behavior: contain;\n    z-index: 9;\n}\n.page-layout__content-wrapper.page-layout__content--desktop-closed {\n    padding-left: 84px;\n}\n.page-layout__content-wrapper{\n    overflow: auto;\n    padding: var(--safe-area-top) 0 var(--safe-area-bottom) 0;\n}\n@media screen and (min-width: 960px) {\n    .page-layout__content-wrapper {\n        display: grid;\n        flex-direction: row-reverse;\n        grid-template-columns: 2fr 3fr;\n        height: 100vh;\n    }\n    .page-layout__dashboard--desktop .page-layout__content-wrapper,\n    .page-layout__content--co2meters.page-layout__content-wrapper {\n        grid-template-columns: 3fr 2fr;\n    }\n    .page-layout__secondary-content {\n        position: relative;\n        grid-column: 2 /2;\n        grid-row: 1;\n    }\n\n    .page-container--desktop.page-layout__dashboard--desktop {\n\n        grid-template-columns: auto  1fr;\n        grid-column: 1 / 1;\n    }\n\n    .page-content {\n        width: 100%;\n    }\n\n    .page-layout__content.page-layout__primary-content {\n        border-right: 1px solid var(--app-border-secondary-color-light);\n    }\n\n    .page.page-smart-home.page-desktop{\n        position: absolute;\n        left: 80px;\n        right: 0;\n    }\n\n}\n\n@media screen and (min-width: 1125px) {\n    .page-layout__sidebar{\n        position: relative;\n        width: 285px;\n    }\n    .page.page-smart-home.page-desktop{\n        position: absolute;\n        left: 0;\n        right: 0;\n    }\n\n}\n\n@media screen  and (min-width: 1280px) {\n    .page-layout__content-wrapper {\n        max-width: 1280px;\n        margin: 0 auto;\n        width: 100%;\n    }\n}\n@media screen and (min-width: 1620px){\n\n\n    .parent-page .page-content{\n        padding-left: 0 ;\n    }\n    .parent-page .page-content{\n        padding-left: 0 ;\n    }\n\n    .child-page .page-content{\n        padding-right: 0 ;\n    }\n\n}\n\n.child-page.page-layout__content > .page{\n    position: sticky;\n    top: 0;\n    overflow: auto;\n}\n.parent-page {\n    overflow: auto;\n    min-width: 320px;\n}\n.parent-page::-webkit-scrollbar {\n    width: 3px;\n    height: auto;\n    background-color: white;\n}\n.parent-page::-webkit-scrollbar-thumb{\n    background-color: var(--app-secondary-color__bg-gray);\n    border-radius: 20px;\n}\n\n.page-smart-home .page-layout__content.page-layout__primary-content{\n    border-right: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
